import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const featuredBlocks = document.querySelectorAll('.featured-recipes-block');

  if (0 < featuredBlocks.length) {
    featuredBlocks.forEach((block) => {
      const mainCarousel = block.querySelector(
        '.featured-recipes__main-carousel'
      );
      const thumbsCarousel = block.querySelector(
        '.featured-recipes__thumbnail-carousel'
      );
      const mainSlides = mainCarousel.querySelectorAll('.swiper-slide');
      const mainArgs = {
        navigation: {
          prevEl: block.querySelector('.swiper-button-prev'),
          nextEl: block.querySelector('.swiper-button-next'),
        },
        pagination: {
          el: block.querySelector(
            '.featured-recipes__main-carousel__pagination'
          ),
          clickable: true,
        },
      };

      if (1 < mainSlides.length) {
        mainArgs.loop = true;
      } else {
        mainArgs.loop = false;
        mainArgs.watchOverflow = true;
      }

      if (thumbsCarousel) {
        const thumbsCarouselSwiper = new Swiper(thumbsCarousel, {
          slidesPerView: 'auto',
        });
        mainArgs.thumbs = {
          swiper: thumbsCarouselSwiper,
        };
      }

      new Swiper(mainCarousel, mainArgs);
    });
  }

  // ------------------ Hide when we use the facet filters
  const FWP = window.FWP;

  document.addEventListener('facetwp-loaded', function () {
    if ('' !== FWP.buildQueryString()) {
      document.querySelector('.main').classList.add('hideFeatured');
    } else {
      document.querySelector('.main').classList.remove('hideFeatured');
    }
  });

  domReady(() => {
    if (FWP) {
      FWP.auto_refresh = true;
    }
  });
});
